import type { OpeningHours } from './types/sales-site.types';

export const DEFAULT_OPENING_HOURS: OpeningHours = {
    defaultOpeningHours: [
        {
            weekday: 1,
            morningStart: '9:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
        {
            weekday: 2,
            morningStart: '9:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
        {
            weekday: 3,
            morningStart: '9:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
        {
            weekday: 4,
            morningStart: '9:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
        {
            weekday: 5,
            morningStart: '9:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
        {
            weekday: 6,
            morningStart: '09:00',
            morningEnd: '18:00',
            afternoonStart: null,
            afternoonEnd: null,
            byAppointment: null,
        },
    ],
    specialOpeningHours: [],
};
